import { useTranslation } from "@opendash/i18n";
import { Form, Input } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { PathContext } from "../../../context/PathContext";
import { FormItemPath } from "../../../types/Config";

type Props = {};

export const HelpInput = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return (
    <Form.Item<FormItemPath>
      label={t("maintenance:ticket.create.config.general.help.label")}
      name={[...path, "help"]}
      layout="vertical"
      help={t("maintenance:ticket.create.config.general.help.help")}
    >
      <Input />
    </Form.Item>
  );
});
